import React, { useState, useEffect } from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import { publicAPI } from '../../services/api';
import { formatDate } from '../../utils/helpers';
import SectionHeader from '../common/SectionHeader';
import LoadingSpinner from '../common/LoadingSpinner';
import { FiBriefcase } from 'react-icons/fi';
import './ExperienceTimeline.css';

const ExperienceTimeline = () => {
  const [experiences, setExperiences] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ref, isVisible] = useScrollAnimation();

  useEffect(() => {
    publicAPI.getExperiences()
      .then(res => { if (res.success) setExperiences(res.data); })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="section timeline-section" ref={ref}>
      <div className="container">
        <SectionHeader title="Work Experience" subtitle="My professional journey" />
        {loading ? <LoadingSpinner /> : (
          <div className={`timeline ${isVisible ? 'fade-in' : ''}`}>
            {experiences.map(exp => (
              <div key={exp.id} className="timeline-item">
                <div className="timeline-marker">
                  <FiBriefcase />
                </div>
                <div className="timeline-content card">
                  <div className="timeline-header">
                    <h3>{exp.position}</h3>
                    <span className="timeline-date">
                      {formatDate(exp.startDate)} - {exp.isCurrent ? 'Present' : formatDate(exp.endDate)}
                    </span>
                  </div>
                  <h4 className="timeline-company">{exp.companyName}</h4>
                  <p className="timeline-desc">{exp.description}</p>
                  {exp.achievements?.length > 0 && (
                    <ul className="timeline-achievements">
                      {exp.achievements.map((achievement, i) => (
                        <li key={i}>{achievement}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default ExperienceTimeline;
